import { render } from "./BottomNavbar.vue?vue&type=template&id=132fc2c9"
import script from "./BottomNavbar.vue?vue&type=script&lang=js"
export * from "./BottomNavbar.vue?vue&type=script&lang=js"

import "./BottomNavbar.vue?vue&type=style&index=0&id=132fc2c9&lang=css"

import exportComponent from "/Users/gareth/Documents/UW/Global Madison Atlas Final/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__